export default [{
    lang: 'en',
    name: 'world',
    title: '.world 世界、领域',
    price: '40.00',
    intro: '.world 寓意、世界，释义公司在线业务是世界的<br>互联网在线业务是世界的，或者线下实体经济业务是世界的。是商业公司/ 企业的可选域名。您购买了吗？',
    subhead: '.world 寓意、世界，释义公司在线业务是世界的',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.world域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.world域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.world全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.world一直是国内外企业宣传及品牌推广的选择！'
  },
  {
    lang: 'en',
    name: 'work',
    title: '.work 职业/ 招聘领域的选择',
    price: '37.00',
    intro: '.work域名寓意工作，通俗易懂。<br>.work 是专为就业服务、招聘人员和人力资源部门推出的域名，他们可以通过这个既独特又便于记忆的域名吸引当地或全世界的应聘者。您购买了吗？',
    subhead: '.work域名寓意工作，通俗易懂。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.work域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.work域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.work全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.work一直是国内外企业宣传及品牌推广的选择！'
  },
  {
    lang: 'en',
    name: 'wiki',
    title: '.wiki 自由、免费、开放',
    price: '249.00',
    intro: '.wiki，维基百科。<br>.wiki域名，可用于介绍各类品牌、产品以及学科知识等，注册无限制，任何人可以自由申请。据海外媒体消息，开放注册前5家知名大品牌企业率先向新顶级域名.Wiki注册商提交申请，申请注册“.wiki”域名，以抢先做好品牌域名保护工作。您购买了吗？',
    subhead: '.wiki，维基百科。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.wiki域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.wiki域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.wiki全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.wiki一直是国内外企业宣传及品牌推广的选择！'
  },
  {
    lang: 'en',
    name: 'wang',
    title: '.wang 寓意王牌、网络、互联网的选择！',
    price: '48.00',
    intro: '.wang域名，寓意网络，互联网、王牌域名！<br>.wang域名音同“网”，符合中国人的记忆和拼音习惯，容易联想到“某某网”，带有比较清晰的门户网站、行业网站的含义，互联网时代的域名！ 例如：fangchan.wang（房产网）、qiche.wang（汽车网）、wang.wang（旺旺）您购买了吗？',
    subhead: '.wang域名，寓意网络，互联网、王牌域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.wang域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.wang域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.wang全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.wang一直是国内外企业宣传及品牌推广的选择，如百度、谷歌、苹果、亚马逊等均纷纷注册.wang域名！'
  },
  {
    lang: 'en',
    name: 'vip',
    title: '.vip域名尊贵、地位的象征！',
    price: '36.00',
    intro: '.vip域名 天生自带尊贵感，象征着高贵、特权、与众不同，其含义及适用范围不言而喻。<br>从VIP的含义来看，这是一个值得全世界关注和使用的域名后缀，其象征着身份、价值、便利、优质服务等不同于众的服务，有着尊贵、奢华、专享等优点，更加便于理解和记忆。您购买了吗？',
    subhead: '.vip域名 天生自带尊贵感，象征着高贵、特权、与众不同，其含义及适用范围不言而喻。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '无论线上还是线下，VIP随处可见，且已成为全球各地的通用词汇，在全球范围内具有高度统一的辨识度。',
    featureSec: '.VIP域名应用场景众多，VIP会员、VIP邮箱等。且广泛应用于各行各业：电商、视频、教育、旅游、服务业等... ',
    featureThi: '.vip通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.VIP域名本身便能直接传达出企业顾客至上的服务理念，以及尊贵、专属、高端的第一感觉。     '
  },
  {
    lang: 'en',
    name: 'top',
    title: '.top域名塑造企业品牌，彰显行业地位！',
    price: '29.00',
    intro: '.top域名 寓意“巅峰”、“顶级”、“高端”，中文谐音为“突破”，彰显公司活力和蒸蒸日上的势头，是企业网站的好选择。<br>.top域名的发展势如破竹，是注册量从100万增长到200万只花了3个月的新顶级域名您购买了吗？',
    subhead: '.top域名 寓意“巅峰”、“顶级”、“高端”，中文谐音为“突破”，彰显公司活力和蒸蒸日上的势头，是企业网站的好选择。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.top域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.top域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.top全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.top一直是国内外企业宣传及品牌推广的选择，如百度、谷歌、苹果、亚马逊等均纷纷注册.top域名！'
  },
  {
    lang: 'en',
    name: 'tech',
    title: '.tech技术领域域名所属！',
    price: '78.00',
    intro: '.tech域名 技术领域专属域名<br>.tech域名新产品、新技术互动交流平台建站的选择。您购买了吗？',
    subhead: '.tech域名 技术领域专属域名',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.tech域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.tech域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.tech全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.tech一直被国内外企业尊为企业宣传及品牌首选，也备受域名投资人的青睐！'
  },
  {
    lang: 'en',
    name: 'store',
    title: '.store域名电商行业的选择！',
    price: '20.00',
    intro: '.store 寓意商店/零售，可成为网上超市、零售便利网店的专属域名。<br>.store域名 它既适合当下的初创企业，也非常适合希望向互联网销售迈进的传统家庭生意。您购买了吗？',
    subhead: '.store 寓意商店/零售，可成为网上超市、零售便利网店的专属域名。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.store域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.store域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.store全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.store一直是国内外企业宣传及品牌推广的选择，如百度、谷歌、苹果、亚马逊等均纷纷注册.store域名！'
  },
  {
    lang: 'en',
    name: 'site',
    title: '.site域名站点 / 网站，网络服务的选择！',
    price: '40.00',
    intro: '.site域名 寓意站点、网站，极具识别度，利于网站推广，互联网建站优选<br>.site域名是"站点"的专属域名，比较适合垂直行业网站使用，有利于产生长久的用户访问习惯。在Alexa网站排名中，.Site域名是第五大网站终端最多的新顶级域名。您购买了吗？',
    subhead: '.site域名 寓意站点、网站，极具识别度，利于网站推广，互联网建站优选',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.site域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.site域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.site全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.site一直是国内外企业宣传及品牌推广的选择，如谷歌、苹果、亚马逊等均纷纷注册.site域名！'
  },
  {
    lang: 'en',
    name: 'shop',
    title: '.shop电商品牌的专属域名！',
    price: '249.00',
    intro: '.shop域名，寓意商店、工厂、购物等，自带商业属性！<br>.shop是购物领域的新顶级域域名！不管是线上或线下的产品和服务，.shop都是商家的网络地址及有力的营销工具。作为引领电子商务潮流的新顶级域名，.shop致力于为各个商业领域提供一个可靠的、有意义的、值得信赖的命名空间。您购买了吗？',
    subhead: '.shop域名，寓意商店、工厂、购物等，自带商业属性！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '无论线上还是线下，shop随处可见，且已成为全球各地的通用词汇，在全球范围内具有高度统一的辨识度。',
    featureSec: '在.shop观念早已深入人心的今天，.shop域名本身便能直接传达出购物及商场的场景。',
    featureThi: '.shop域名通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.shop域名应用场景众多，shop专属商铺、产品官网等。且广泛应用于各行各业：电商、视频、教育、旅游等领域'
  },
  {
    lang: 'en',
    name: 'online',
    title: '.online互联网在线服务的选择！',
    price: '49.00',
    intro: '.online域名 表示在线，寓意网络在线等<br>.online 互联网时代讲究的是在线的生活，在线已成为我们一种生活方式。您购买了吗？',
    subhead: '.online域名 表示在线，寓意网络在线等',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.online域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.online域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.online全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.online一直是国内外企业宣传及品牌推广的选则，也备受域名投资人的青睐！'
  },
  {
    lang: 'en',
    name: 'ltd',
    title: '.ltd域名 有限公司的专属名片！',
    price: '28.00',
    intro: '.ltd域名，寓意公司、是有限公司的专属域名！<br>建立国际企业品牌形象、与全球企业同步，从LTD企业官网开始。企业官网使用.Ltd域名，域名即公司名，公司名即域名，真正实现域、名合一，能极大地提升官网的正统性、权威性，彰显品牌优势，不仅好记、易识别，而且可以更好更方便地进行推广宣传。您购买了吗？',
    subhead: '.ltd域名，寓意公司、是有限公司的专属域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.ltd域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.ltd域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.ltd域名通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.ltd一直是国内外企业宣传及品牌推广的选择！'
  },
  {
    lang: 'en',
    name: 'link',
    title: '.link寓意链接！',
    price: '112.00',
    intro: '.link寓意“链接”，互联网缩短了我们与世界的距离。 <br>link表示的含义为: 链接；环节；联系；关系等，自发行来一直受到各域名爱好者、公司、投资者的青睐。您购买了吗？',
    subhead: '.link寓意“链接”，互联网缩短了我们与世界的距离。 ',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.link域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.link域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.link全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.link一直是国内外企业宣传及品牌推广的选择，也备受域名投资人的青睐！'
  },
  {
    lang: 'en',
    name: 'ink',
    title: '.ink“Inter Net King ”互联网之王！！',
    price: '249.00',
    intro: '.ink域名是国际新通用顶级域名（New Generic Top-level Domain 简称 New gTLD）<br>.ink域名其中文音译有"赢客"、"印刻"、"英客"、"迎客"等，有吉祥、记录、通达、欢迎之意，ink域名非常适合油墨行业、油漆行业、墨水文具行业做品牌推广。您购买了吗？',
    subhead: '.ink域名是国际新通用顶级域名（New Generic Top-level Domain 简称 New gTLD） ',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.ink域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.ink域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.ink全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.ink一直是国内外企业宣传及品牌推广的选择，如百度、谷歌、苹果、亚马逊等均纷纷注册.net域名！'
  },
  {
    lang: 'en',
    name: 'gold',
    title: '.gold 黄金 珠宝行业的选择',
    price: '40.00',
    intro: '.gold 新顶级域名<br>.gold 为珠宝商，银行，黄金转现金企业，科学家和博客提供的顶级域名（TLD）， 适用于珠宝商，银行业务和黄金现金业务的人。您购买了吗？',
    subhead: '.gold 新顶级域名',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.gold域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.gold域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.gold全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.gold一直是国内外企业为企业宣传及品牌推广做出的选择！'
  },
  {
    lang: 'en',
    name: 'group',
    title: '.group集团 / 团体专属域名！',
    price: '30.00',
    intro: '.group可理解为集团、团体、群组、类别等，是打造集团品牌，提高用户粘度和可信度的精品域名。 对于各种盈利与非盈利的公司集团、公益与非公益组织、娱乐与非娱乐群组，均可适用。<br>域名注册时默认serverhold，直至域名通过实名认证，您购买了吗？',
    subhead: '.group可理解为集团、团体、群组、类别等，是打造集团品牌，提高用户粘度和可信度的精品域名。 对于各种盈利与非盈利的公司集团、公益与非公益组织、娱乐与非娱乐群组，均可适用。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.group域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.group域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.group全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.group一直是国内外企业宣传及品牌推广的选择，如百度、谷歌、苹果、亚马逊等均纷纷注册.group域名！'
  },
  {
    lang: 'en',
    name: 'fund',
    title: '.fund 基金、储备、现款基金行业的选择',
    price: '40.00',
    intro: '.fund域名由ICANN批准的顶级域名管理局Donuts倾心打造的国际顶级域名，支持英语、德语、法语以及西班牙语等多国语言。是提升本企业互联网品牌影响力较为合适的域名。<br>.fund 专为基金及其相关行业而设，适用于任何与投资、共有基金、股票市场、公司贷款、信用额度相关企业。您购买了吗？',
    subhead: '.fund域名由ICANN批准的顶级域名管理局Donuts倾心打造的国际顶级域名，支持英语、德语、法语以及西班牙语等多国语言。是提升本企业互联网品牌影响力较为合适的域名。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.fund域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.fund域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.fund全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.fund一直是国内外企业为企业宣传及品牌推广做出的选择！'
  },
  {
    lang: 'en',
    name: 'design',
    title: '.design 设计领域专属域名',
    price: '599.00',
    intro: '.design，Internet网络域名。它由Starting Dot公司申请注册并运行。.design域名是国际顶级域名，是供设计类网站使用的域名。<br>.design域名设计领域，或品牌形象传播、广告宣传类网站优选。您购买了吗？',
    subhead: '.design，Internet网络域名。它由Starting Dot公司申请注册并运行。.design域名是国际顶级域名，是供设计类网站使用的域名。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.design域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.design域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.design全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.design一直被国内外企业尊为企业宣传及品牌首选！'
  },
  {
    lang: 'en',
    name: 'co',
    title: '.co简短便于记忆，创业时代的选择！',
    price: '299.00',
    intro: '.co域名是英文"Corporation、Company"（商业公司）的缩写，含义明确、简单易记，方便公众理解。<br>.在.com域名资源日渐枯竭的今天，.co域名的推出，无疑是给企业客户带来了更多新选择。您购买了吗？',
    subhead: '.co域名是英文"Corporation、Company"（商业公司）的缩写，含义明确、简单易记，方便公众理解。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.CO在全球市场广泛适用。由于其含义丰富，在 全球各个地区没有语言和区域上的障碍。',
    featureSec: '数百万成功企业都在使用.CO域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '作为新顶级域名，.CO拥有超过多年的可靠使用记录，值得信赖',
    featureFour: '.CO一直被国内外企业尊为企业宣传及品牌选择，也备受域名投资人的青睐！如亚马逊、谷歌、LeWeb等'
  },
  {
    lang: 'en',
    name: 'art',
    title: '.art域名艺术领域的选择！',
    price: '126.00',
    intro: '.Art代表艺术、文艺（包含戏剧、文学、音乐、绘画等）<br>.Art旨在建造艺术世界的网络基础设施将会带来更多的创作自由、更高的信息透明度，让艺术创作者、消费者有更优质的选择，并建立起一个更强大的艺术社区。您购买了吗？',
    subhead: '.Art代表艺术、文艺（包含戏剧、文学、音乐、绘画等）',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.Art在全球市场广泛适用。由于其含义丰富，在 全球各个地区没有语言和区域上的障碍。',
    featureSec: '数百万成功企业都在使用.Art域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '作为新顶级域名，.Art拥有超过多年的可靠使用记录，值得信赖',
    featureFour: '.Art一直是国内外企业为企业宣传及品牌做出的选择，也备受域名投资人的青睐！如亚马逊、谷歌、LeWeb等'
  },
  {
    lang: 'en',
    name: '购物',
    title: '.购物域名电商行业的选择！',
    price: '2800.00',
    intro: '.购物域名 通俗易懂，更符合国人的电商网络域名<br>.购物远不只是一个简单的域名。加入.购物，宣示你的想法值得全世界瞩目。.购物 寓意明确更加便于理解和记忆。您购买了吗？',
    subhead: '.购物域名 通俗易懂，更符合国人的电商网络域名',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.购物在全球市场广泛适用。由于其含义丰富，在 全球各个地区没有语言和区域上的障碍。',
    featureSec: '数百万成功企业都在使用.购物域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '作为最早建立的域名，.购物拥有超过多年的可靠使用记录，值得信赖',
    featureFour: '.购物一直被国内外企业宣传及品牌推广的选择，也备受域名投资人的青睐！如亚马逊、谷歌、LeWeb等'
  },
  {
    lang: 'en',
    name: 'company',
    title: '.company域名企业网络形象的选择！',
    price: '40.00',
    intro: '.company域名表示的含义为:公司；陪伴；同伴；连队<br>.company域名，不论您是线上公司还是实体店，.COMPANY域名都能将您的业务信息从网上传递出去。您购买了吗？',
    subhead: '.company域名表示的含义为:公司；陪伴；同伴；连队',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.company域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.company域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.company全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.company一直是国内外企业为企业宣传及品牌做出的选择！'
  }, {
    lang: 'en',
    name: '在线',
    title: '.在线切合中文习惯的域名！',
    price: '1980.00',
    intro: '.在线寓意明确。<br>企业、公司的首选！<br>.在线作为一款中文顶级域名，完全符合中文的语言习惯、审美标准、法律法规，以及商业文化，.在线一直被国内外企业尊为企业宣传及品牌首选。 您购买了吗？',
    subhead: '',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.在线域名是目前全球注册增长最快的域名，有时选择比努力更重要！',
    featureSec: '数百万成功企业都在使用.在线域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.在线通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.在线一直被国内外企业尊为企业宣传及品牌首选，如百度、谷歌、苹果、亚马逊等均纷纷注册.在线域名！'
  }, {
    lang: 'cn',
    name: '在线',
    title: '.在线切合中文习惯的域名！',
    price: '1980.00',
    intro: '.在线寓意明确。<br>企业、公司的首选！<br>.在线作为一款中文顶级域名，完全符合中文的语言习惯、审美标准、法律法规，以及商业文化，.在线一直被国内外企业尊为企业宣传及品牌首选。 您购买了吗？',
    subhead: '',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.在线域名是目前全球注册增长最快的域名，有时选择比努力更重要！',
    featureSec: '数百万成功企业都在使用.在线域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.在线通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.在线一直被国内外企业尊为企业宣传及品牌首选，如百度、谷歌、苹果、亚马逊等均纷纷注册.在线域名！'
  },
  {
    lang: 'cn',
    name: 'com',
    title: '.COM互联网公司优选的顶级域名！',
    price: '180.00',
    intro: '.com为company简称，表示公司企业，中文.com即为含有中文字元的.com域名。<br>中文.com域名符合国际标准，使用上和.com域名近似，是目前国际广泛流行的通用域名格式，现全球用户超过1.1亿个。众多国际化公司都会注册.com域名。',
    subhead: 'com域名是目前国际广泛流行的通用域名格式，是企业注册优质选择域名！',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.com域名目前在全球的注册量已超过1.1亿，是全球流行的域名。',
    featureSec: '.com、.net、.org同为目前国际广泛流行的通用域名格式。',
    featureThi: '世界上众多知名公司都选择.com域名，利用.com进行网站宣传',
    featureFour: '.com是早出现的域名后缀之一，极具资历，在网络上具有良好的信誉。'
  },
  {
    lang: 'cn',
    name: 'cn',
    title: '.cn域名企业互联网品牌标识！',
    price: '150.00',
    intro: '.cn为china简称，表示中国，中文.cn即为含有中文字元的.cn域名。<br>企业塑造品牌不二之选！<br>中文.cn域名符合国际标准，使用上和.cn域名近似，是目前国际广泛流行的国家域名格式，现全球用户超过2000万个。众多国际化公司进入中国都会选择.cn域名，如亚马逊的z.cn。',
    subhead: '.cn域名是国际广泛流行的国家域名，现全球用户超过2000万个。是中国企业自己的互联网标识！',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.cn域名是中国企业自己的互联网标识，它体现了一种文化的认同',
    featureSec: '选择注册.cn域名的企业越来越多，已经超越.com，成为全球颇具影响力的的通用域名',
    featureThi: 'CN比国外域名更为简短，且CN的域名资源丰富，世界上众多知名公司都选择.cn域名，利用.cn进行网站宣传',
    featureFour: '.由中国管理的国际顶级域名，受中国法律保护。'
  },
  {
    lang: 'cn',
    name: 'biz',
    title: '.biz代表商业的新顶级域名！',
    price: '150.00',
    intro: '.biz是英文单词 "business"（商务）的缩写，代表着商业领域，中文.biz即为含有中文字元的.biz域名。<br>中文.biz域名符合国际标准，使用上和.biz域名近似，是全球颇具竞争力的国际顶级域名。',
    subhead: '.net域名诞生于上世纪80年代，与.com域名、.org域名被世界上从事互联网的人尊称为国际顶级域名',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.net域名与.com、.cn、.org同为目前国际广泛流行的通用域名',
    featureSec: '.net通俗易懂，识别度高，含义精确提升品牌价值！',
    featureThi: '用于从事Internet相关的网络服务的机构或公司，树立全球商业品牌及国际化形象',
    featureFour: '.net是早出现的域名后缀之一，极具资历，在网络上具有良好的信誉。'
  },
  {
    lang: 'en',
    name: 'com',
    title: '.COM互联网公司优选的顶级域名！',
    price: '180.00',
    intro: '.com为company简称，表示公司企业。<br> .com是目前国际广泛流行的通用域名格式，现全球用户超过1.1亿个。众多国际化公司都会注册.com域名。<br> .com 是首批顶级域名 (TLD) 之一，于 1985 年 1 月创建，自此发展为全球热销的 TLD。现如今已经存在 几十个其他 TLD，但是无论出现了多少个新的域名后缀，人们还是一致认为 .com 依旧是“Web 的当家花旦” 您购买了吗？',
    subhead: 'com域名是目前国际广泛流行的通用域名格式，是企业注册优质选择域名！',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.com域名目前在全球的注册量已超过1.1亿，是全球流行的域名。',
    featureSec: '.com、.net、.org同为目前国际广泛流行的通用域名格式。',
    featureThi: '世界上众多知名公司都选择.com域名，利用.com进行网站宣传',
    featureFour: '.com是早出现的域名后缀之一，极具资历，在网络上具有良好的信誉。'
  },
  {
    lang: 'en',
    name: 'cn',
    title: '.cn域名企业互联网品牌标识！',
    price: '150.00',
    intro: '.cn为china简称，表示中国。<br>企业塑造品牌不二之选！<br>.cn是目前国际广泛流行的国家域名格式，现全球用户超过2000万个。众多国际化公司进入中国都会选择.cn域名，如亚马逊的z.cn。<br>.cn域名一直很受国外个人、公司及投资者青睐，现如今在全球国别域名中保有量一直遥遥领先。您购买了吗？',
    subhead: '.cn域名是国际广泛流行的国家域名，现全球用户超过2000万个。是中国企业自己的互联网标识！',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.cn域名是中国企业自己的互联网标识，它体现了一种文化的认同',
    featureSec: '选择注册.cn域名的企业越来越多，已经超越.com，成为全球颇具影响力的的通用域名',
    featureThi: 'CN比国外域名更为简短，且CN的域名资源丰富，世界上众多知名公司都选择.cn域名，利用.cn进行网站宣传',
    featureFour: '.由中国管理的国际顶级域名，受中国法律保护。'
  },
  {
    lang: 'en',
    name: 'net',
    title: '.net建立全球商业品牌的域名优质选择！',
    price: '180.00',
    intro: '.net国际广泛流行的通用域名。<br>.net域名诞生于上世纪80年代，一般用于从事internet相关网络服务的机构公司，是建立全球商业品牌，国际化形象的优质选择。您购买了吗？',
    subhead: '.net域名诞生于上世纪80年代，与.com域名、.org域名被世界上从事互联网的人尊称为国际顶级域名',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.net域名与.com、.cn、.org同为目前国际广泛流行的通用域名',
    featureSec: '.net通俗易懂，识别度高，含义精确提升品牌价值！',
    featureThi: '用于从事Internet相关的网络服务的机构或公司，树立全球商业品牌及国际化形象',
    featureFour: '.net是早出现的域名后缀之一，极具资历，在网络上具有良好的信誉。'
  },
  {
    lang: 'en',
    name: 'biz',
    title: '.biz代表商业的新顶级域名！',
    price: '240.00',
    intro: '.biz是英文单词 "business"（商务）的缩写，代表着商业领域。<br>全球颇具竞争力的国际顶级域名。<br>在com资源日渐枯竭的情况下，biz拥有众多的域名可供选择，biz必将代替com成为企业注册域名的优质选择。 您购买了吗？',
    subhead: '.biz是.com的有力竞争者和替代者，是代表商业领域的顶级域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.biz域名是新的国际顶级域名，资源丰富，.com的有力竞争者和替代者。',
    featureSec: '数百万成功企业都在使用.biz域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.biz通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.biz代表商业（business），能有效帮您建立、强化和扩展网络业务而设计的国际顶级域名。'
  },
  {
    lang: 'en',
    name: 'info',
    title: '.info域名网络时代的标识！',
    price: '240.00',
    intro: '.info域名为国际顶级域名，代表信息服务，是信息时代明确的标志。<br>.info的特点是全球通用、易于使用、识别性强，可以替代.com使用，适用于提供信息服务的企业。您购买了吗？',
    subhead: '.info是国际顶级域名，是信息服务和信息时代明确的标志！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.info域名是新的国际顶级域名，资源丰富，.com的有力竞争者和替代者。',
    featureSec: '数百万成功企业都在使用.info域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.info全球通用、通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.info一直被国内外企业尊为企业宣传及品牌优质选择，如谷歌、苹果、亚马逊等均纷纷注册.info域名！'
  },
  {
    lang: 'en',
    name: 'mobi',
    title: '.mobi企业移动推广的优质选择！',
    price: '70.00',
    intro: '.mobi域名是企业建设WAP网站的优质选择。.mobi域名是手机及移动端设备的专用域名，由爱立信、GSM协会、Google、微软、诺基亚、三星电子、Syniverse科技、T-Mobile等全球顶级知名手机厂商和相关行业协会共同投资。您购买了吗？',
    subhead: '.mobi域名是全球唯一专为手机及移动端设备打造的域名，是移动互联网优质选择域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.mobi是全球知名互联网公司共同发起及统一标准，致力于移动端更好的畅游互联网！',
    featureSec: '数百万成功企业都在使用.mobi域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '微软、谷歌、诺基亚、三星等国际巨头技术支持，鼎力发展！',
    featureFour: '.mobi一直被国内外企业尊为企业宣传及品牌优质选择，如宝马中国.mobi、加多宝中国.mobi、欧珀莱.mobi、华夏银行.mobi、顺丰速运.mobi等。'
  },
  {
    lang: 'cn',
    name: '中国',
    title: '.中国塑造中国品牌的国家域名！',
    price: '320.00',
    intro: '.中国域名，在互联网上代表中国的全中文顶级域名。它不仅是多语种域名，也是我国国家域名体系的重要组成部分。<br>根据信息产业部域名体系公告，“．中国”是在互联网上标识中的，“．CN”是在互联网上标识中国的英文顶级域名。<br>.中国域名因独特的含义，使命非凡，发行来发展势如破竹，目前日增幅位列新顶级域名之首，吸粉无数，期待指数严重爆表！ 您购买了吗？',
    subhead: '.中国域名作为中国国家域名目前增势非常快的域名，是企业注册优质选择域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.中国域名是目前全球注册增长非常快的域名',
    featureSec: '数百万成功企业都在使用.中国域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.中国人自己的域名，使用方便，便于记忆，含义精确提升品牌价值！',
    featureFour: '.中国一直被国内外企业尊为企业宣传及品牌优质选择，如百度、谷歌、苹果、亚马逊等均纷纷注册.中国域名！'
  },
  {
    lang: 'cn',
    name: '公司',
    title: '.公司域名自带品牌宣传效果！',
    price: '320.00',
    intro: '.公司域名适合商业应用的新中文通用顶级域名。<br>“.公司”是早申请并入根的新中文通用顶级域名之一，由中国互联网络信息中心（简称CNNIC）负责运营管理，于2014年1月21日正式写入全球互联网根域名系统。“.公司”具有全球通用的唯一性，被业界称为中文的“.com”，适用于商业应用，是企业在网络的“中文门牌号”。<br>.公司域名是企业在网络的独有标志，也是企业品牌、产品、形象、商业信誉等方便的综合体现。您购买了吗？',
    subhead: '.公司域名是企业在网络的独有标志，适合商业应用的新中文通用顶级域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '后缀使用中文的域名，独具特色，在国际互联网中体现中华文化。',
    featureSec: '“.公司”作为企业无形资产的重要组成部分，是企业在品牌、产品、形象、商业信誉等方面的综合体现。',
    featureThi: '.早申请并入根的新中文通用顶级域名之一，由中国互联网络信息中心（简称CNNIC）负责运营管理，于2014年1月21日正式写入全球互联网根域名系统',
    featureFour: '具有全球通用的唯一性，被业界称为中文的“.com”，适用于商业应用，是企业在网络的“中文门牌号"。'
  },
  {
    lang: 'cn',
    name: '网络',
    title: '.网络极具互联网标识的中文域名！',
    price: '320.00',
    intro: '.网络域名是新一代域名，是互联网的门牌号码。<br>.中文域名属于互联网上的基础服务，注册后可以对外提供WWW、Email、FTP等应用服务.中国互联网络信息中心（CNNIC）负责运行和管理以“.CN”、“.中国”、“.公司”、“.网络”结尾的四种中文顶级域名。<br>.网络具有很高辨识度，非常适合应用于网络服务。您购买了吗？',
    subhead: '.网络具有中国特色的域名，是互联网的门牌号码',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '中文后缀的域名更容易被中国人理解，易于识别记忆。',
    featureSec: '任何企业、组织、个人都可以注册',
    featureThi: '后缀使用中文的域名，独具特色，在国际互联网中体现中华文化。',
    featureFour: '.网络域名是由中国互联网络信息中心（CNNIC）负责运行和管理的中文顶级域名'
  },
  {
    lang: 'cn',
    name: '网址',
    title: '.网址国内网址标识类域名！',
    price: '2800.00',
    intro: '.网址域名是ICANN批准面向全球的新顶级域名，根据国外namestat统计机构“.网址”域名注册量达到20万。<br>启用.网址企业不禁更加贴合国人用户搜索需求，全球通用，认知度高，还能够起到一定的推广效果。<br>“.网址”通用顶级域名注册管理机构的使命是，通过.网址这一个中文国际顶级域名来向全球中文网络用户提供领先的通用顶级域名注册管理服务，中文国际化通用顶级域名(IDN TLD)是中国人熟悉的描述网址的词。.网址域名能为用户提供方便记忆和浏览中文网站的方法。 您购买了吗？',
    subhead: '.网址是ICANN批准面向全球的新顶级域名，方便国人记忆和浏览中文网站的域名。',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.网址中文国际化通用顶级域名(IDN TLD)是中国人熟悉的描述网址的词',
    featureSec: '根据国外namestat统计机构“.网址”域名注册量达到20万',
    featureThi: '.网址域名是ICANN批准面向全球的新顶级域名，能为用户提供方便记忆和浏览中文网站的方法',
    featureFour: '.网址企业不禁更加贴合国人用户搜索需求，全球通用，认知度高，还能够起到一定的推广效果。'
  },
  {
    lang: 'cn',
    name: '中文网',
    title: '.中文网域名有效保护中文网址品牌！',
    price: '1800.00',
    intro: '.中文网作为一款中文新通用顶级域名，赋予企业本地商业化特征。<br>.中文网语义清晰明确而且符合中国文化习惯。是企业推广中文企业品牌、产品和中文网站的优质结合。<br>.中文网域名资源丰富，以商业化的姿态走上国际舞台，与新老通用顶级域名百花齐放。 您购买了吗？',
    subhead: '.中文网一款中文新通用顶级域名，是企业推广中国品牌的优质选择域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.中文网域名是目前全球注册增长非常快的域名',
    featureSec: '数百万成功企业都在使用.中文网域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.中文网通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '中文网是个人及商业网站的优质选择，也是中文新闻及媒体网站的绝佳之选。'
  },
  {
    lang: 'cn',
    name: '企业',
    title: '.企业域名为企业量身打造的顶级域名！',
    price: '1200.00',
    intro: '.企业域名为企业提供顶级域名。<br>.企业为域名开放更多可用性和选项，为企业树立品牌形象，具有便于用户和消费者辨认的 基本功能，是企业颇具互联网品牌实力的域名。您购买了吗？',
    subhead: '.企业域名是为企业打造的顶级域名，是企业树立品牌形象明显的标志！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.企业域名是新的顶级域名，寓意明显，独具特色。',
    featureSec: '数百万成功企业都在使用.企业域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.企业域名、通俗易懂，识别度高，含义精确提升企业品牌价值！',
    featureFour: '.企业代表企业，能有效帮您建立、强化和扩展网络业务。'
  },
  {
    lang: 'cn',
    name: '手机',
    title: '.手机移动互联网品牌推广利器！',
    price: '2960.00',
    intro: '.手机域名，手机端专属域名。<br>.手机具有鲜明的移动互联网属性！<br>“.com”等域名面向互联网，而“.手机”面向移动互联网。移动互联网时代，“.手机”助力企业抓住新的时代机遇。 您购买了吗？',
    subhead: '.手机域名是目前国际广泛流行的新通用域名格式，目前增势非常快的域名，是企业移动互联网优质选择域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.手机域名是目前全球注册增长非常快的域名',
    featureSec: '数百万成功企业都在使用.手机域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.手机通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.手机一直被国内外企业尊为企业宣传及品牌优质选择，如尼康、ARM、唯品会、长安汽车等均纷纷注册.top域名！'
  },
  {
    lang: 'cn',
    name: '网店',
    title: '.网店域名电商品牌优选！',
    price: '1280.00',
    intro: '.网店，寓意明确。<br>企业塑造电商品牌的不二之选！<br>.网店域名自2016年3月21日新网首发来发展势如破竹，知名互联网公司均注册.网店域名，如苹果、京东、谷歌、宝马均已选择.网店令.网店吸粉无数，期待指数严重爆表！ 您购买了吗？',
    subhead: '.网店域名是目前中文领域为电商量身打造的一款域名。是电商优质选择域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.网店域名是目前全球注册增长非常快的域名',
    featureSec: '数百万成功企业都在使用.网店域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.网店通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.网店一直被国内外企业尊为企业宣传及品牌优质选择，如百度、谷歌、苹果、亚马逊等均纷纷注册.网店域名！'
  },
  {
    lang: 'cn',
    name: '集团',
    title: '.集团域名优质诠释企业实力！',
    price: '12000.00',
    intro: '公司名/商标/产品/品牌高度一致。<br>公司名/商标/产品/品牌高度一致。<br>.集团为新通用顶级域（new gTLD），专为集团级企业及有意发展 为集团企业的公司设立的高端中文域名，与“集团”名称意义 一致，有利于展现品牌实力，具有便于用户和消费者辨认的 基本功能，是颇具互联网品牌实力的域名后缀购买了吗？',
    subhead: '.集团域名是目前国际广泛流行的新通用域名格式，目前增势非常快的域名，是企业注册优质选择域名！',
    ppxcName: '值得信赖',
    zdxlName: '具备商业价值',
    featureFir: '.企业独享关键字，建立竞争壁垒， 降低宣传成本。',
    featureSec: '数百万成功企业都在使用.集团域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.集团通俗易懂，识别度高，含义精确提升品牌价值！',
    featureFour: '.集团一直被国内外企业尊为企业宣传及品牌优质选择，如百度、亚马逊、苏宁、格力等均纷纷注册.集团域名！'
  },
  {
    lang: 'en',
    name: 'com.cn',
    title: '.com.cn企业互联网品牌标识！',
    price: '150.00',
    intro: '.cn为china简称，表示中国。<br>它体现了一种文化的认同、自身的价值和定位。<br>.cn域名是由我国管理的国际顶级域名，是中国自己的互联网标识。<br>当前cn域名在全球具有较大的市场，适合任何企业、组织、个人注册。您购买了吗？',
    subhead: '.cn域名是由中国管理的国际顶级域名，是中国企业自己的互联网标识，它体现了一种文化的认同、自身的价值和定位。',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.cn域名是中国企业自己的互联网标识，它体现了一种文化的认同',
    featureSec: '选择注册.cn域名的企业越来越多，已经超越.com，成为全球颇具影响力的的通用域名',
    featureThi: '.cn比国外域名更为简短，且cn的域名资源丰富，世界上众多知名公司都选择.cn域名，利用.cn进行网站宣传',
    featureFour: '.由中国管理的国际顶级域名，受中国法律保护。'
  },
  {
    lang: 'en',
    name: 'net.cn',
    title: '.net.cn域名企业互联网品牌标识！',
    price: '150.00',
    intro: '.cn为china简称，表示中国。<br>它体现了一种文化的认同、自身的价值和定位。<br>.cn域名是由我国管理的国际顶级域名，是中国自己的互联网标识。<br>当前cn域名在全球具有较大的市场，适合任何企业、组织、个人注册。您购买了吗？',
    subhead: '.cn域名是由中国管理的国际顶级域名，是中国企业自己的互联网标识，它体现了一种文化的认同、自身的价值和定位。',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.cn域名是中国企业自己的互联网标识，它体现了一种文化的认同',
    featureSec: '选择注册.cn域名的企业越来越多，已经超越.com，成为全球颇具影响力的的通用域名',
    featureThi: '.cn比国外域名更为简短，且cn的域名资源丰富，世界上众多知名公司都选择.cn域名，利用.cn进行网站宣传',
    featureFour: '.由中国管理的国际顶级域名，受中国法律保护。'
  },
  {
    lang: 'en',
    name: 'org.cn',
    title: '.org.cn域名企业互联网品牌标识！',
    price: '150.00',
    intro: '.cn为china简称，表示中国。<br>它体现了一种文化的认同、自身的价值和定位。<br>.cn域名是由我国管理的国际顶级域名，是中国自己的互联网标识。<br>当前cn域名在全球具有较大的市场，适合任何企业、组织、个人注册。您购买了吗？',
    subhead: '.cn域名是由中国管理的国际顶级域名，是中国企业自己的互联网标识，它体现了一种文化的认同、自身的价值和定位。',
    ppxcName: '品牌宣传',
    zdxlName: '值得信赖',
    featureFir: '.cn域名是中国企业自己的互联网标识，它体现了一种文化的认同',
    featureSec: '选择注册.cn域名的企业越来越多，已经超越.com，成为全球颇具影响力的的通用域名',
    featureThi: '.cn比国外域名更为简短，且cn的域名资源丰富，世界上众多知名公司都选择.cn域名，利用.cn进行网站宣传',
    featureFour: '.由中国管理的国际顶级域名，受中国法律保护。'
  },
  {
    lang: 'en',
    name: 'club',
    title: '.club寓意精准，网聚人气的域名！',
    price: '150.00',
    intro: '.club域名是是位于美国佛罗里达州CLUBDOCT公司，创业者科林·坎贝尔（Tucows的，Hostopia）成立的。.CLUB是俱乐部和会员制组织、在线社交网络平台的通用顶级域名新顶级域名“.club” 可用于搭建交友、 社交、 教育等各类网站平台， 运用范围相当广阔。 您购买了吗？',
    subhead: '.cn域名是由中国管理的国际顶级域名，是中国企业自己的互联网标识，它体现了一种文化的认同、自身的价值和定位。',
    ppxcName: '具备商业价值',
    zdxlName: '值得信赖',
    featureFir: '.club域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.club域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.club被国内外企业尊为企业宣传及品牌首选，如Poker.club，Book.club，Golf.club，Wine.club等均选择.club！',
    featureFour: '.club全球通用、通俗易懂，识别度高，含义精确提升品牌价值！'
  },
  {
    lang: 'en',
    name: 'xyz',
    title: '.xyz富有想象力和探索空间的域名！',
    price: '150.00',
    intro: 'xyz域名是新通用顶级域名（New Generic Top-level Domain 简称 New gTLD）顶级域名“.XYZ” 是26个英文字母中的最后三个字母， 相较于其他由单词构成的新顶级域名来说，“.XYZ” 域名简单易记， 应用范围广。 您购买了吗？ ',
    subhead: '.cn域名是由中国管理的国际顶级域名，是中国企业自己的互联网标识，它体现了一种文化的认同、自身的价值和定位。',
    ppxcName: '具备商业价值',
    zdxlName: '值得信赖',
    featureFir: '.xyz域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.xyz域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.xyz被国内外企业尊为企业宣传及品牌首选，如谷歌、The Engine等均纷纷注册.xyz域名！',
    featureFour: '.xyz全球通用、通俗易懂，识别度高，含义精确提升品牌价值！'
  },
  {
    lang: 'cn',
    name: 'club',
    title: '.club寓意精准，网聚人气的域名！',
    price: '150.00',
    intro: '.club域名是是位于美国佛罗里达州CLUBDOCT公司，创业者科林·坎贝尔（Tucows的，Hostopia）成立的。.CLUB是俱乐部和会员制组织、在线社交网络平台的通用顶级域名新顶级域名“.club” 可用于搭建交友、 社交、 教育等各类网站平台， 运用范围相当广阔。 您购买了吗？',
    subhead: '.cn域名是由中国管理的国际顶级域名，是中国企业自己的互联网标识，它体现了一种文化的认同、自身的价值和定位。',
    ppxcName: '具备商业价值',
    zdxlName: '值得信赖',
    featureFir: '.club域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.club域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.club被国内外企业尊为企业宣传及品牌首选，如Poker.club，Book.club，Golf.club，Wine.club等均选择.club！',
    featureFour: '.club全球通用、通俗易懂，识别度高，含义精确提升品牌价值！'
  },
  {
    lang: 'cn',
    name: 'xyz',
    title: '.xyz富有想象力和探索空间的域名！',
    price: '150.00',
    intro: 'xyz域名是新通用顶级域名（New Generic Top-level Domain 简称 New gTLD）顶级域名“.XYZ” 是26个英文字母中的最后三个字母， 相较于其他由单词构成的新顶级域名来说，“.XYZ” 域名简单易记， 应用范围广。 您购买了吗？ ',
    subhead: '.cn域名是由中国管理的国际顶级域名，是中国企业自己的互联网标识，它体现了一种文化的认同、自身的价值和定位。',
    ppxcName: '具备商业价值',
    zdxlName: '值得信赖',
    featureFir: '.xyz域名是增长较快的新国际顶级域名，富有投资潜力。',
    featureSec: '数百万成功企业都在使用.xyz域名，现在注册即刻迈出发展业务的重要一步',
    featureThi: '.xyz被国内外企业尊为企业宣传及品牌首选，如谷歌、The Engine等均纷纷注册.xyz域名！',
    featureFour: '.xyz全球通用、通俗易懂，识别度高，含义精确提升品牌价值！'
  }
]



// WEBPACK FOOTER //
// ./static/assets/info-intro-data.js